// XAU/USD Risk & Position Sizing Calculator
// Standard lot: 1 lot = 100 oz; $1 price move = $100 P&L per lot
// Formula: lots = risk_$ / (sl_distance × 100)

export const calcDollarRisk = (balance, riskPercent) =>
  parseFloat(((balance * riskPercent) / 100).toFixed(2));

export const calcLotSize = (dollarRisk, entry, sl) => {
  const dist = Math.abs(parseFloat(entry) - parseFloat(sl));
  if (!dist || dist === 0) return null;
  const lots = dollarRisk / (dist * 100);
  return {
    lots:     parseFloat(lots.toFixed(2)),
    microLots: parseFloat((lots * 100).toFixed(0)),  // 0.01 unit count
    slDistance: parseFloat(dist.toFixed(2)),
    slPips:    parseFloat((dist * 100).toFixed(0)),   // XAU pip = $0.01
  };
};

export const calcRR = (entry, sl, tp) => {
  const e = parseFloat(entry), s = parseFloat(sl), t = parseFloat(tp);
  if (isNaN(e) || isNaN(s) || isNaN(t) || e === s) return null;
  const risk   = Math.abs(e - s);
  const reward = Math.abs(t - e);
  return {
    risk:    parseFloat(risk.toFixed(2)),
    reward:  parseFloat(reward.toFixed(2)),
    ratio:   parseFloat((reward / risk).toFixed(2)),
    text:    `1:${(reward / risk).toFixed(1)}`,
  };
};

export const calcTodayStats = (trades) => {
  const today = new Date().toISOString().split('T')[0];
  const todayTrades = trades.filter(t => t.date && t.date.startsWith(today));
  const closed = todayTrades.filter(t => t.status === 'Closed');
  const pnl    = closed.reduce((sum, t) => sum + (parseFloat(t.pnl) || 0), 0);
  return {
    tradeCount: todayTrades.length,
    closedCount: closed.length,
    wins:  closed.filter(t => t.result === 'WIN').length,
    losses: closed.filter(t => t.result === 'LOSS').length,
    pnl:   parseFloat(pnl.toFixed(2)),
  };
};

export const getRiskStatus = (todayStats, settings, currentDrawdown = 0) => {
  const maxDailyLoss = (settings.account_balance * settings.max_daily_loss_percent) / 100;
  const usedTrades   = todayStats.tradeCount;
  const maxTrades    = settings.max_daily_trades;
  const lossToday    = Math.abs(Math.min(todayStats.pnl, 0));

  const lossPercent  = (lossToday / maxDailyLoss) * 100;
  const tradePercent = (usedTrades / maxTrades) * 100;

  if (lossToday >= maxDailyLoss || usedTrades >= maxTrades) {
    return { level: 'RED',    label: 'STOP TRADING', color: '#ff3333', reason: lossToday >= maxDailyLoss ? 'Daily loss limit hit' : 'Max trades reached' };
  }
  if (lossPercent >= 70 || tradePercent >= 70) {
    return { level: 'YELLOW', label: 'CAUTION',       color: '#ffd700', reason: 'Approaching daily limit' };
  }
  return   { level: 'GREEN',  label: 'SAFE TO TRADE', color: '#00ff88', reason: 'Within risk limits' };
};
